const NOT_FOUND_IMAGES_BASE_PATH = "/images/404"

export const NOT_FOUND_IMAGE_SOURCES = {
  mobile: `${NOT_FOUND_IMAGES_BASE_PATH}/404-375.png`,
  tablet: `${NOT_FOUND_IMAGES_BASE_PATH}/404-834.png`,
  desktop: `${NOT_FOUND_IMAGES_BASE_PATH}/404-1440.png`,
  desktopXl: `${NOT_FOUND_IMAGES_BASE_PATH}/404-1920.png`,
} as const
